import { ONBOARDING_TARGETS } from '@/constants/onboarding';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface HighlightTarget {
    selector: string;
    featureLabel: string;
}

export interface HelperState {
    opened: boolean;
    highlightedTarget: HighlightTarget | null;
    forceSidebarExpanded: boolean;
}

const initialState: HelperState = {
    opened: false,
    highlightedTarget: null,
    forceSidebarExpanded: false
};

const helperSlice = createSlice({
    name: 'helper',
    initialState,
    reducers: {
        openHelper: (state) => {
            state.opened = true;
        },
        closeHelper: (state) => {
            state.opened = false;
        },
        toggleHelper: (state) => {
            state.opened = !state.opened;
        },
        setHighlightedTarget: (state, action: PayloadAction<HighlightTarget>) => {
            state.highlightedTarget = action.payload;
            state.forceSidebarExpanded = [
                ONBOARDING_TARGETS.security,
                ONBOARDING_TARGETS.accountNavigation,
                ONBOARDING_TARGETS.sidebar
            ].includes(action.payload.selector);
        },
        clearHighlightedTarget: (state) => {
            state.highlightedTarget = null;
            state.forceSidebarExpanded = false;
        }
    }
});

export const { openHelper, closeHelper, toggleHelper, setHighlightedTarget, clearHighlightedTarget } =
    helperSlice.actions;

export const selectHelperOpened = (state: RootState) => state.helper.opened;
export const selectHelperHighlightedTarget = (state: RootState) => state.helper.highlightedTarget;
export const selectHelperForceSidebarExpanded = (state: RootState) => state.helper.forceSidebarExpanded;

export default helperSlice.reducer;
